export default __webpack_public_path__ + "static/daring-9a1117d9949f02f340427effc85624e9.svg";